/*
 * Makes the whole media card clickable using the link already set on the card's
 * button block. Nothing new for the merchant to fill in: the "Shop Now" button
 * stays the single source of truth for the destination.
 *
 * A parent theme block can't read a child block's settings in Liquid, so the
 * href is mirrored on the client instead.
 */
(() => {
  const CARD_SELECTOR = ".custom-grid-item";
  const MEDIA_SELECTOR = ".media-grid-media";
  const BUTTON_SELECTOR = ".media-grid-content a.content-btn[href]";
  const LINKED_CLASS = "media-grid-card-linked";
  const INTERACTIVE_SELECTOR = "a, button, input, label, select, textarea, [role='button']";

  const boundCards = new WeakSet();

  function getCardLink(card) {
    const link = card.querySelector(BUTTON_SELECTOR);
    if (!link) return null;
    const href = link.getAttribute("href");
    if (!href || href === "#") return null;
    return link;
  }

  function handleClick(event) {
    // Keep the theme editor usable: clicks there select blocks, not navigate.
    if (window.Shopify && Shopify.designMode) return;

    // Let real controls (the button itself, app widgets) handle their own clicks.
    if (event.target.closest(INTERACTIVE_SELECTOR)) return;

    // Don't hijack a click that ends a text selection.
    const selection = window.getSelection();
    if (selection && selection.toString().length > 0) return;

    // Read the link on click so a URL edited in the editor is always current.
    const link = getCardLink(event.currentTarget);
    if (!link) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey || link.target === "_blank") {
      window.open(link.href, "_blank", "noopener");
      return;
    }

    window.location.href = link.href;
  }

  function setupCard(card) {
    card.classList.toggle(LINKED_CLASS, getCardLink(card) !== null);
    if (boundCards.has(card)) return;
    boundCards.add(card);
    card.addEventListener("click", handleClick);
  }

  function setup() {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (!card.querySelector(MEDIA_SELECTOR)) return;
      setupCard(card);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }

  // Re-scan after the theme editor re-renders a section or block.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", setup);
    document.addEventListener("shopify:block:select", setup);
  }
})();
